import React from "react";
import { Slang } from "../../../helpers";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import config from "../../../config";
import axios from "axios";

const Index = () => {
  const lang = Slang("dashboardNavbar");
  const token = useSelector((state) => state.auth && state.auth.token.value);

  const handleLogout = async () => {
    console.log("token logout", token);

    try {
      const response = await axios.post(
        `${config.apiUrl}/user/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("response logout", response.data.data);
      sessionStorage.clear();
      localStorage.removeItem("persist:auth");

      toast.success("Déconnexion réussie");
      // dispatch(authActions.logout());
    } catch (error) {
      console.log(" error logout", error);
      localStorage.removeItem("persist:auth");
    } finally {
      setTimeout(() => {
        window.location.href = "/login";
      }, 3000);
    }
  };
  return (
    <>
      <div className="dropdown">
        <a
          href="profile"
          className="nav-link link-primary dropdown-toggle"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {lang("t2")}
        </a>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li>
            <Link to="/dashboard" className="dropdown-item" href="#">
              <i className="bi bi-columns-gap"></i> {lang("t1")}
            </Link>
          </li>
          <li>
            <Link to="/dashboard/profile" className="dropdown-item" href="#">
              <i className="bi bi-person-circle"></i> {lang("t2")}
            </Link>
          </li>
          <li>
            <hr className="" />
          </li>
          <li>
            <span
              className="dropdown-item"
              href="#"
              style={{ cursor: "pointer" }}
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right"></i> {lang("t3")}
            </span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Index;
